import {IActionModel} from "../../shared/models/action.model";
import {SET_FACILITY_DETAILS, SET_LOCATION_DETAILS} from "../actions/facilityAndLocation.action";
const INITIAL_STATE: any = {
    facilityDetails:{},
    locationDetails:{}
};
const facilityAndLocationDetailsReducer = (state: any = INITIAL_STATE, action: IActionModel): any => {
    switch (action.type) {
        case SET_FACILITY_DETAILS:
            return {
                ...state,
                facilityDetails: action.payload,
            };
        case SET_LOCATION_DETAILS:
            return {
                ...state,
                locationDetails: action.payload,
            }
        default:
            return state;
    }
};

export default facilityAndLocationDetailsReducer;